"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BillingAddress = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _skeletons = require("../skeletons");
var _BillingAddressContent = require("./BillingAddressContent");
var _styles = require("./styles");
var _useBillingAddress = require("./useBillingAddress");
var _jsxRuntime = require("react/jsx-runtime");
const BillingAddress = (param)=>{
    let { billingAddressRootRef, addressFormat } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { billingAddressContentProps, isDeliveryChannelSelected, isQueryLoading } = (0, _useBillingAddress.useBillingAddress)();
    const { billingState } = (0, _contexts.useNavigationContext)();
    // Loading of billing address data is disabled if no delivery channel is selected.
    // So there is no point trying to insert another address via address form in this state.
    if (billingState === 'disabled' || !isDeliveryChannelSelected) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BillingAddressWrapper, {
            inert: "",
            ...getTestIdProps(_models.TestId.BillingAddressDisabled),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SectionHeader, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.DisabledTitle, {
                    variant: "h6",
                    component: "h2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                        id: "billingAddress"
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.BillingAddressWrapper, {
        ref: billingAddressRootRef,
        ...getTestIdProps(_models.TestId.BillingAddress),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SectionHeader, {
                ...getTestIdProps(_models.TestId.BillingAddressHeader),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                    variant: "h6",
                    component: "h2",
                    ...getTestIdProps(_models.TestId.BillingAddressTitle),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                        id: "billingAddress"
                    })
                })
            }),
            billingState === 'loading' || isQueryLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_skeletons.BillingAddressSkeleton, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_BillingAddressContent.BillingAddressContent, {
                ...billingAddressContentProps,
                addressFormat: addressFormat
            })
        ]
    });
};
exports.BillingAddress = BillingAddress;
